"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerEventAssetType = void 0;
var ProducerEventAssetType;
(function (ProducerEventAssetType) {
    ProducerEventAssetType["Ceremony"] = "ceremony";
    ProducerEventAssetType["Student"] = "student";
    ProducerEventAssetType["Intro"] = "intro";
    ProducerEventAssetType["Outro"] = "outro";
    ProducerEventAssetType["Media"] = "media";
    ProducerEventAssetType["Stageclip"] = "stageclip";
})(ProducerEventAssetType = exports.ProducerEventAssetType || (exports.ProducerEventAssetType = {}));
//# sourceMappingURL=producer-event-asset-type.js.map